import { useState } from "react";
import ClientInfoStep from "../components/intake/ClientInfoStep";
import ProjectDetailsStep from "../components/intake/ProjectDetailsStep";
import DeliveryModelStep from "../components/intake/DeliveryModelStep";
import ToolsHostingStep from "../components/intake/ToolsHostingStep";
import AgreementStep from "../components/intake/AgreementStep";

export default function IntakeWizard() {
  const [step, setStep] = useState(1);
  const next = () => setStep(step + 1);
  const back = () => setStep(step - 1);

  return (
    <div className="page">
      <h2>Project Intake</h2>

      {step === 1 && <ClientInfoStep onNext={next} />}
      {step === 2 && <ProjectDetailsStep onNext={next} onBack={back} />}
      {step === 3 && <DeliveryModelStep onNext={next} onBack={back} />}
      {step === 4 && <ToolsHostingStep onNext={next} onBack={back} />}
      {step === 5 && <AgreementStep />}
    </div>
  );
}
